<template>
  <div>
    <div class="px-7 py-3 d-flex justify-center text-align">
      <!-- By locking this User's account, they will no longer be able to log in to
      access their benefits, their courses, or buy Member-specific products from
      the store -->
      {{ message }}
    </div>
    <div class="px-7 pb-0 d-flex justify-center">
      <span class="text-heading mb-5"
        >
        <!-- IF YOU ARE SURE YOU WANT TO LOCK THE ACCOUNT, CLICK SUBMIT. -->
        {{ confirmMessage }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: String,
    confirmMessage: String
  }
};
</script>

<style scoped>
.text-heading {
  font-family: "Noto Serif";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 34px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.text-align {
  text-align: center;
}
</style>
